import {
  capabilitiesImpact,
  capabilitiesPriorities,
} from "@features/assessments-feature/constants";
import { impactColor } from "@features/assessments-feature/utils/assessmentsColors";
import assessmentViewsMap from "@features/assessments-feature/utils/assessmentViewsMap";
import { AssessmentProgram } from "@lib/ShiOneClient";
import shiColors from "shared-ui/src/theme/shiColors";

export function isProgramSprV2(program: string) {
  const assessmentProgram = assessmentViewsMap.get(program ?? "")?.id;
  return assessmentProgram === AssessmentProgram.SecurityPostureReviewV2;
}

export function getPriorities(isSprV2: boolean) {
  if (isSprV2) {
    return [
      {
        key: "shortTerm",
        label: capabilitiesPriorities.shortTermV2,
        value: capabilitiesPriorities.shortTermV2,
      },
      {
        key: "mediumTerm",
        label: capabilitiesPriorities.mediumTermV2,
        value: capabilitiesPriorities.mediumTermV2,
      },
      {
        key: "longTerm",
        label: capabilitiesPriorities.longTermV2,
        value: capabilitiesPriorities.longTermV2,
      },
    ];
  }
  return [
    {
      key: "doNow",
      label: `${capabilitiesPriorities.doNow} (Short Term)`,
      value: capabilitiesPriorities.doNow,
    },
    {
      key: "doLater",
      label: `${capabilitiesPriorities.doLater} (Long Term)`,
      value: capabilitiesPriorities.doLater,
    },
  ];
}

export function getImpacts(isSprV2: boolean) {
  if (isSprV2) {
    return [
      {
        key: "high",
        label: capabilitiesImpact.highImpactV2,
        value: "High",
        color: shiColors.red.DEFAULT,
      },
      {
        key: "medium",
        label: capabilitiesImpact.mediumImpactV2,
        value: "Medium",
        color: shiColors.orange.DEFAULT,
      },
      {
        key: "low",
        label: capabilitiesImpact.lowImpactV2,
        value: "Low",
        color: shiColors.yellow.DEFAULT,
      },
    ];
  }
  return [
    {
      key: "highImpact",
      label: capabilitiesImpact.highImpact,
      value: capabilitiesImpact.highImpact,
      color: impactColor[capabilitiesImpact.highImpact.toLowerCase()],
    },
    {
      key: "lowImpact",
      label: capabilitiesImpact.lowImpact,
      value: capabilitiesImpact.lowImpact,
      color: impactColor[capabilitiesImpact.lowImpact.toLowerCase()],
    },
  ];
}
